module.exports = __webpack_public_path__ + "img/bandlab-main.113b900a.svg";